import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Dotcom2024Service } from '../../dotcom2024.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { MyharrellsService } from '../../myharrells.service';

@Component({
  selector: 'app-teams',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './teams.component.html',
  styleUrl: './teams.component.css'
})
export class TeamsComponent {
  constructor(public myHarrellsService: MyharrellsService, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, public router: Router) { }

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Teams/";
  employeePhotosImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Employee-Photos/";

  execTeam: any[] = [];
  deptTeam: any[] = [];
  departments: any[] = [];
  selectedDeptId: number = 0;

  showEmpsgrid: boolean = false;

  ngOnInit() {

    this.dotComService.activePage = "teams"

    //meta tags for SEO
    this.title.setTitle("Meet the Harrell’s Team | Leadership & Employee-Owners");
    this.meta.updateTag({ name: 'description', content: "Harrell’s is built on core values and strong leadership. Meet our dedicated employee-owners and learn how we support customers and the industry." });
    this.meta.updateTag({ property: 'og:title', content: "Meet the Harrell’s Team | Leadership & Employee-Owners" });
    this.meta.updateTag({ property: 'og:description', content: "Harrell’s is built on core values and strong leadership. Meet our dedicated employee-owners and learn how we support customers and the industry." });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here -  teams" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here -  teams" });
    this.meta.updateTag({ property: 'Twitter:card', content: "Meet the Harrell’s Team | Leadership & Employee-Owners" });
    this.meta.updateTag({ property: 'Twitter:site', content: "Meet the Harrell’s Team | Leadership & Employee-Owners" });
    this.meta.updateTag({ property: 'Twitter:title', content: "Meet the Harrell’s Team | Leadership & Employee-Owners" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Harrell’s is built on core values and strong leadership. Meet our dedicated employee-owners and learn how we support customers and the industry." });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here -  teams" });

    this.GetExecTeam()
    this.GetDepartments()
  }

  GetExecTeam() {
    this.dotComService.GetEmployees('Employees', '', 999).subscribe(data => {
      this.execTeam = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        element.email = element.email.toLowerCase(); //make sure all emails are lower case
        //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
        this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".jpg", (exists) => {
          if (exists) {
            // Success code
            //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
            element.empPhoto = this.employeePhotosImagePaths + element.Id + ".jpg";
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".png", (exists) => {
              if (exists) {
                // Success code
                element.empPhoto = this.employeePhotosImagePaths + element.Id + ".png";
              } else {
                // Fail code - use default
                element.empPhoto = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });

        this.execTeam.push(element)
      }

    })
  }

  GetDepartments() {
    this.departments = [];
    this.dotComService.GetDepartments().subscribe(data => {
      this.departments = data;
      this.departments.push({ name: 'Operations', Id: 11111 }) //this isnt really a dept in our depts table
      this.departments.sort((a, b) => (a.name > b.name) ? 1 : -1);
      this.departments.unshift({ name: 'All Departments', Id: 0 }) //add this one to the beginning
      this.departments.unshift({ name: '--Select--', Id: -1 }) //default - they must select to show any 

      //since id defaults to the first one in the list, display those people
      this.selectedDeptId = parseInt(data[0].Id);
      this.GetSelectedTeamsEmployees()

    })
  }

  GetSelectedTeamsEmployees() {
    document.getElementById("spinnerModal").style.display = "block";
    this.showEmpsgrid = false
    this.deptTeam = [];
    let reqType = 'Employees';
    let loc = '';
    let deptId = this.selectedDeptId;

    if (this.selectedDeptId == 11111) {
      //user selected the customer service team which is not a real department in our depts table
      reqType = 'GetSiteServiceEmployees'
      loc = ''
      deptId = 0
    }




    this.dotComService.GetEmployees(reqType, loc, deptId).subscribe(data => {
      if (data.length == 0) {
        document.getElementById("spinnerModal").style.display = "none";
      }

      //sort data by last name
      data.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1);

      this.deptTeam = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];

        console.log("element", element.LastName + ", " + element.FirstName)

        //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
        this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".jpg", (exists) => {
          if (exists) {
            // Success code
            //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
            element.empPhoto = this.employeePhotosImagePaths + element.Id + ".jpg";
            //cehck if element.id exists in the deptTeam array, if not add it
            if (this.deptTeam.findIndex(x => x.Id == element.Id) == -1) {
              this.deptTeam.push(element)
              this.deptTeam.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1);
            }

            if (index == data.length - 1) {
              document.getElementById("spinnerModal").style.display = "none";
              this.showEmpsgrid = true; //set this to true so the grid shows after all images have been checked
            }
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".png", (exists) => {
              if (exists) {
                // Success code
                element.empPhoto = this.employeePhotosImagePaths + element.Id + ".png";
                if (this.deptTeam.findIndex(x => x.Id == element.Id) == -1) {
                  this.deptTeam.push(element)
                  this.deptTeam.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1);
                }
                if (index == data.length - 1) {
                  document.getElementById("spinnerModal").style.display = "none";
                  this.showEmpsgrid = true; //set this to true so the grid shows after all images have been checked
                }
              } else {
                if (index == data.length - 1) {
                  document.getElementById("spinnerModal").style.display = "none";
                  this.showEmpsgrid = true; //set this to true so the grid shows after all images have been checked
                }
                // Fail code - use default
                //element.empPhoto = this.baseImagePaths + "harrellsh.png"
                //NOT SHOWING THE EMPLOYEE IF THEY DO NOT HAVE A PHOTO - LIKE BRANDON WHO DOES NOT WANT A PHOTO 
              }
            })
          }
        });

        // if (index ==  data.length - 1) {
        //   this.showEmpsgrid = true; //set this to true so the grid shows after all images have been checked
        // }

        // this.deptTeam.push(element)
      }

    })


  }

  ChangeOpacity(id: string) {
    document.getElementById(id).style.opacity = '.1';
    document.getElementById(id + 'detail').style.display = 'block'
  }

  ChangeOpacityBack(id: string) {
    document.getElementById(id).style.opacity = '1';
    document.getElementById(id + 'detail').style.display = 'none'
  }

  GetDirections(warehouse: any) {
    window.open("https://www.google.com/maps/dir//" + warehouse.address + ", " + warehouse.city + ", " + warehouse.state + " " + warehouse.zip, "_blank");
  }

}
